<template>
    <div class="main">
        <c-panel title="MOVIMENTAÇÃO ESCOLAR" titleIcon="fas fa-exchange-alt">

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregar">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola (opcional)" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable clearable placeholder="Toda a rede" style="width: 100%;" @change="carregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10" class="u-text-right">
                        <el-button class="u-mt-25" icon="el-icon-refresh" @click="carregar">ATUALIZAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-tabs v-model="aba" @tab-click="carregar">

                <el-tab-pane label="Sintético" name="sintetico">
                    <div class="container-table" v-if="sintetico">
                        <table class="table table-striped">
                            <thead><tr><th>Escola</th><th class="u-text-center">Matrículas</th><th class="u-text-center">Saídas</th><th>Distribuição por situação</th></tr></thead>
                            <tbody>
                                <tr v-for="e in sintetico.escolas" :key="e.instituicao_id">
                                    <td>{{ e.instituicao }}</td>
                                    <td class="u-text-center">{{ e.total }}</td>
                                    <td class="u-text-center">{{ e.saidas }}</td>
                                    <td>
                                        <span v-for="(s, i) in e.situacoes" :key="i" class="chip">{{ s.rotulo }}: {{ s.total }}</span>
                                    </td>
                                </tr>
                                <tr v-if="sintetico.escolas.length === 0"><td colspan="4" class="u-text-center">Nenhuma movimentação no período.</td></tr>
                            </tbody>
                        </table>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="Analítico" name="analitico">
                    <el-alert v-if="analitico && analitico.aviso" type="warning" :closable="false" class="u-mb-15" :title="analitico.aviso"></el-alert>
                    <div class="container-table" v-if="analitico">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Aluno</th>
                                    <th class="hidden-mobile">Matrícula</th>
                                    <th class="hidden-mobile">Escola</th>
                                    <th class="hidden-mobile">Curso / Turma</th>
                                    <th class="u-text-center">Situação</th>
                                    <th class="u-text-center">Tipo</th>
                                    <th class="hidden-mobile">Motivo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(l, i) in analitico.linhas" :key="i">
                                    <td>{{ l.aluno }}</td>
                                    <td class="hidden-mobile">{{ l.num_matricula }}</td>
                                    <td class="hidden-mobile">{{ l.instituicao }}</td>
                                    <td class="hidden-mobile">{{ l.curso }} / {{ l.turma || '—' }}</td>
                                    <td class="u-text-center">{{ l.situacao }}</td>
                                    <td class="u-text-center">{{ rotuloTipo(l.tipo) }}</td>
                                    <td class="hidden-mobile">{{ l.motivo || '—' }}</td>
                                </tr>
                                <tr v-if="analitico.linhas.length === 0"><td colspan="7" class="u-text-center">Nenhuma linha.</td></tr>
                            </tbody>
                        </table>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="Gráfico" name="grafico">
                    <div v-if="grafico">
                        <!--
                            Mesma stack de gráficos já usada em evolucao-aluno e tabulacao
                            (vue-chartjs via @/chart/BarChart.js). A tabela abaixo permanece:
                            ela é a leitura exata dos mesmos números e é o que vai para a
                            impressão e para quem precisa conferir valor a valor.
                        -->
                        <div v-if="grafico.labels.length" class="u-mb-20">
                            <bar-chart :chart-data="dadosGrafico" :height="320"></bar-chart>
                        </div>

                        <div class="container-table">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Mês</th>
                                        <th class="u-text-center" v-for="s in grafico.series" :key="s.nome">{{ s.nome }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(m, i) in grafico.labels" :key="m">
                                        <td>{{ m }}</td>
                                        <td class="u-text-center" v-for="s in grafico.series" :key="s.nome">{{ s.dados[i] }}</td>
                                    </tr>
                                    <tr v-if="grafico.labels.length === 0"><td :colspan="grafico.series.length + 1" class="u-text-center">Sem dados no período.</td></tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 class="u-mt-20 u-mb-10">Saídas por situação</h4>
                        <div v-if="grafico.saidas_por_situacao.length" class="u-mb-20">
                            <doughnut-chart :chart-data="dadosSaidas" :height="260"></doughnut-chart>
                        </div>
                        <div class="container-table">
                            <table class="table table-striped">
                                <thead><tr><th>Situação</th><th class="u-text-center">Total</th></tr></thead>
                                <tbody>
                                    <tr v-for="s in grafico.saidas_por_situacao" :key="s.codigo">
                                        <td>{{ s.rotulo }}</td>
                                        <td class="u-text-center">{{ s.total }}</td>
                                    </tr>
                                    <tr v-if="grafico.saidas_por_situacao.length === 0"><td colspan="2" class="u-text-center">Nenhuma saída registrada.</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </c-panel>
    </div>
</template>
<script>
import BarChart from '@/chart/BarChart.js'
import DoughnutChart from '@/chart/DoughnutChart.js'

/** BLOCO E — itens 74 e 75: movimentação escolar em três visões. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    components: { BarChart, DoughnutChart },
    data: () => ({
        aba: 'sintetico', periodoId: null, instituicaoId: null,
        instituicoes: [],
        sintetico: null, analitico: null, grafico: null
    }),
    computed: {
        dadosGrafico () {
            if (!this.grafico) return { labels: [], datasets: [] }
            const cores = ['#409EFF', '#F56C6C', '#67C23A', '#E6A23C', '#909399', '#8E44AD']
            return {
                labels: this.grafico.labels,
                datasets: this.grafico.series.map((s, i) => ({
                    label: s.nome, backgroundColor: cores[i % cores.length], data: s.dados
                }))
            }
        },
        dadosSaidas () {
            if (!this.grafico) return { labels: [], datasets: [] }
            const cores = ['#F56C6C', '#E6A23C', '#909399', '#8E44AD', '#409EFF', '#67C23A', '#C0392B', '#16A085']
            return {
                labels: this.grafico.saidas_por_situacao.map(s => s.rotulo),
                datasets: [{
                    backgroundColor: this.grafico.saidas_por_situacao.map((s, i) => cores[i % cores.length]),
                    data: this.grafico.saidas_por_situacao.map(s => s.total)
                }]
            }
        }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) { this.instituicoes = [inst]; this.instituicaoId = inst.id }
        else {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
        }

        this.carregar()
    },
    methods: {
        carregar () {
            if (!this.periodoId) return
            const filtros = { periodo_letivo_id: this.periodoId, instituicao_id: this.instituicaoId }

            if (this.aba === 'sintetico') {
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/movimentacao-escolar/sintetico`,
                    filtros, this.$store.getters.getHeaderAuth
                ).then(r => { this.sintetico = r.data }).catch(e => this.$store.commit('throwException', e))
            } else if (this.aba === 'analitico') {
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/movimentacao-escolar/analitico`,
                    filtros, this.$store.getters.getHeaderAuth
                ).then(r => { this.analitico = r.data }).catch(e => this.$store.commit('throwException', e))
            } else {
                const base = `${this.$store.state.config.baseUrlApi}/api/movimentacao-escolar/grafico/${this.periodoId}`
                this.$axios.get(base + (this.instituicaoId ? '?instituicao_id=' + this.instituicaoId : ''),
                    this.$store.getters.getHeaderAuth
                ).then(r => { this.grafico = r.data }).catch(e => this.$store.commit('throwException', e))
            }
        },
        rotuloTipo (t) {
            return { saida: 'Saída', permanencia: 'Permanência', movimentacao_interna: 'Movimentação interna' }[t] || t
        }
    }
}
</script>
<style scoped>
.chip { display: inline-block; background: #f2f2f2; border-radius: 10px; padding: 1px 8px; margin: 2px; font-size: 11px; }
</style>
